import { MemberInterface } from '@app/core/_models/member-interface';
import { Action } from '@ngrx/store';
import { LoadMember, MemberActions, MemberLoaded } from './member-actions';

export interface State {
  member: Partial<MemberInterface> | null;
  isMemberFetched: boolean;
  isBasicMemberFetched: boolean;
}

const initialState: State = {
  member: null,
  isMemberFetched: false,
  isBasicMemberFetched: false,
};

export function reducer(state = initialState, action: Action): State {
  switch (action.type) {
    case MemberActions.CLEAR_MEMBER: {
      return { ...initialState };
    }
    case MemberActions.LOAD_MEMBER: {
      if (!(<LoadMember>action).force) { return { ...state }; }

      return {
        ...initialState,
      };
    }
    case MemberActions.MEMBER_LOADED: {
      return {
        ...state,
        member: (<MemberLoaded>action).member,
      };
    }
    case MemberActions.MEMBER_FETCHED: {
      return { ...state, isMemberFetched: true, isBasicMemberFetched: true };
    }
    case MemberActions.BASIC_MEMBER_FETCHED: {
      return { ...state, isBasicMemberFetched: true };
    }
    default: { return state; }
  }
}
